export interface WebSocketEnvironment {
  websocket?: string;
  customer?: string;
}

export interface WebSocketMessage<T = unknown> {
  type?: string;
  data: T;
  timestamp?: number;
}

export enum WebSocketConnectionType {
  INSIDE_DEVICES = 'inside-devices',
  INSIDE_GATEWAYS = 'inside-gateways',
  INSIDE_SITES = 'inside-sites',
  /** Cloche d'inside (flux 18) : connexion dédiée, ouverte sur toutes les sections. */
  INSIDE_NOTIFICATIONS = 'inside-notifications',
  CUSTOMER = 'customer',
  /** V7 integrator app — single shared WS connection for live trackers/gateways. */
  INTEGRATOR = 'integrator',
}

export interface WebSocketSubscriptionOptions {
  autoReconnect?: boolean;
  maxRetries?: number;
  retryDelay?: number;
}
